import React from 'react';
import Paper from '@material-ui/core/Paper';
import ThemeProvider from 'anchor-ui/theme-provider';
// import AdminBadge from 'anchor-ui/admin-badge';
//import Button from 'anchor-ui/button';
//import Button from '@material-ui/core/Button';
// import RaisedButton from 'material-ui/RaisedButton';
import List from 'anchor-ui/list';
import ListItem from 'anchor-ui/list-item';
//import { loadConversationList, loadMessagesList } from '../../store/Store';
import withSearch from './withSearch'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
TimeAgo.addLocale(en)
const timeAgo = new TimeAgo('en-US')

const styles = {
  Paper: {
    height: '87vh',
    backgroundColor: '#FFFFFF',
    position: 'relative',
    square: 'square',
    boxShadow: 'none',
    //borderBottom: '1px solid lightgrey',
  },
  SearchBox: {
    height: '6%',
  },
  List: {
    height: '100%',
  },
  ListItem: {
    height: '70px',
    borderBottom: '0.5px solid lightgrey',
  },
  primaryTextStyle: {
    color: '#251447',
    textAlign: 'left',
    fontFamily:'Lucida Grande',
    marginLeft: '11px',
    fontSize: '16px',
  },
  secondaryTextStyle: {
    color: '#807582',
    textAlign: 'left',
    fontFamily:'Lucida Grande',
    marginTop: '1%',
    marginLeft: '11px',
    fontSize: '12px',
  },
  unreadTextStyle: {
    color: '#000',
    fontWeight: 'bold',
    fontFamily:'Lucida Grande',
    marginTop: '1%',
    marginLeft: '11px',
    fontSize: '12px'
  },
  listStyle:{
    //'height': '100%',
  }
}

class ConversationLists extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      activeUserId: ''
    }
  }

  handleClick(id, index) {
    this.setState({activeUserId: id}, () => {
      this.props.setActiveId(this.state.activeUserId)
      this.props.updateProfile(id)
      this.props.pullConversation(id)
    })
    this.setState({active_index: index})
  }
  componentDidMount() {
    
  }
  renderlastMessageTime = (epochTime) => {
    return (
      <ThemeProvider color='#807582'>
        <p style={{fontSize: '10px', textAlign: 'right', color: '#807582'}}>{timeAgo.format(new Date(epochTime), 'twitter')}</p>
      </ThemeProvider>
      
    )
  }

  render(){
    return (
      <Paper style={styles.Paper}>
        {/* <SearchBox style={styles.SearchBox}/> */}
        <ThemeProvider color='#F3F3F3'>
          <List style={styles.List}>
          {
            this.props.conversationList.map((item, index) =>
            item.name ? 
              <ListItem style={styles.ListItem}
                key={index}
                primaryText={item.name}
                primaryTextStyle={styles.primaryTextStyle}
                secondaryText={item.lastMessage}
                secondaryTextStyle={item.read? styles.secondaryTextStyle: styles.unreadTextStyle}
                active={this.active_index !== '' ? index === this.state.active_index : false}
                avatar={item.avatar? item.avatar: './davatar.png'}
                enableinfinitescroll='true'
                liststyle={styles.listStyle}
                onClick = {() => this.handleClick(item.userId, index)}
                //badge = {2} //unread message count
                rightButton = {this.renderlastMessageTime(item.epochTime)}
              /> : null
            )
          }
          </List>
        </ThemeProvider>
      </Paper>
    )
  }
}

export default withSearch(ConversationLists)



// WEBPACK FOOTER //
// ./src/Components/Dashboard/ConversationLists.js